import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Media } from '@digilize/shared/definitions/src';

@Component({
  selector: 'lib-favicon-upload',
  templateUrl: './favicon-upload.component.html',
  styleUrls: ['./favicon-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FaviconUploadComponent {
  @Input() header: string;
  @Input() headerTooltip: string;
  @Input() lightLabel: string;
  @Input() darkLabel: string;
  @Input() faviconLight: Media;
  @Input() faviconDark: Media;
  /* Optional translated hints under each slot, for telling the user where the favicon shown came from. */
  @Input() lightNote: string;
  @Input() darkNote: string;
  @Input() fileTypesString = '.svg, .png, .jpg, .jpeg';

  @Output() lightFilesChange = new EventEmitter<File[]>();
  @Output() darkFilesChange = new EventEmitter<File[]>();
  @Output() lightRemoved = new EventEmitter<void>();
  @Output() darkRemoved = new EventEmitter<void>();
}
